import React from 'react';
import { Link } from 'react-router-dom';
import { MenuListItem } from './styles';

export default ({ rainEnable, storageEnable, seepageEnable, seepageV2Enable }) =>
  storageEnable || seepageEnable || seepageV2Enable || rainEnable ? (
    <MenuListItem className="dropdown">
      <a
        className="dropdown-toggle"
        data-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
      >
        การประมวลข้อมูล <span className="caret" />
      </a>
      <ul className="dropdown-menu">
        {storageEnable && (
          <li>
            <Link to="/water/storage">ปริมาณการกักเก็บน้ำในอ่าง</Link>
          </li>
        )}
        {seepageEnable && (
          <li>
            <Link to="/pressure/seepage">อัตราการรั่วซึม</Link>
          </li>
        )}
        {seepageV2Enable && (
          <li>
            <Link to="/pressure/seepage-v2">กราฟอัตราการรั่วซึม</Link>
          </li>
        )}
        <li>
          <Link to="/pressure/history">กราฟระดับน้ำและแรงดันในแต่ละจุด</Link>
        </li>
        {rainEnable && (
          <li>
            <Link to="/rain/history">ปริมาณน้ำฝน</Link>
          </li>
        )}
      </ul>
    </MenuListItem>
  ) : (
    <MenuListItem>
      <Link to="/pressure/history">กราฟระดับน้ำและแรงดันในแต่ละจุด</Link>
    </MenuListItem>
  );



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuLink/MenuPressureGraph.js